import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import axios from "axios";
import { API } from "./api";

export function useAuthed() {
  const { getToken } = useAuth();
  return useCallback(async (method, path, data) => {
    const token = await getToken();
    return axios({ url: `${API}${path}`, method, data, headers: { Authorization: `Bearer ${token}` } });
  }, [getToken]);
}
